export default {
  errorPage: {
    title: '暂无权限访问目标页面',
    loginButton: '重新登录',
    linkToWorkBench: '前往工作台'
  }
}
